import { api } from "@services/api"

export const POST_PAYMENT_CACHE_TAGS = ["Cart", "Orders", "Wallet"] as const

export const invalidatePostPaymentCache = (dispatch: (action: unknown) => void) => {
  dispatch(api.util.invalidateTags([...POST_PAYMENT_CACHE_TAGS]))
}
